import {atom} from 'recoil';

export const unreadMessageCountState = atom<number>({
  key: 'unreadMessageCountState',
  default: 0,
});
